import { Link } from 'react-router-dom'

export const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="w-full border-t border-border/50 bg-background/95 backdrop-blur-sm">
      <div className="container mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 py-8 px-4 md:px-6">
        <div className="text-center sm:text-left">
          <Link to="/" className="text-xl font-semibold text-foreground">
            Briefly
          </Link>
          <p className="text-sm text-muted-foreground mt-1">
            &copy; {currentYear} Briefly. Todos os direitos reservados.
          </p>
        </div>
        <div className="flex items-center gap-6 text-sm text-muted-foreground">
          <Link to="#" className="hover:text-foreground transition-colors">
            Termos de Serviço
          </Link>
          <Link to="#" className="hover:text-foreground transition-colors">
            Política de Privacidade
          </Link>
        </div>
      </div>
    </footer>
  )
}
